import styles from "./input.module.scss";
import React from "react";

interface InputProps {
    type?: "text" | "number";
    text?: string;
    name?: string;
    value: any;
    readOnly?: boolean;
    className?: string;
    placeholder?: string;
    disabled?: boolean;
    onChange?: (valor: any) => void;
    onFocus?: (e: any) => void;
    onBlur?: (e: any) => void;
    onKeyUp?: (e: any) => void;
    id?: string;
}

export const Input: React.FC<InputProps> = ({
    className,
    text,
    name,
    type,
    value,
    readOnly,
    placeholder,
    onChange,
    onBlur,
    onFocus,
    onKeyUp,
    id,
}) => {
    return (
        <div className={styles.box}>
            {text ? <label className={styles.textLabel}>{text}</label> : false}

            <div className={`${styles.inputGroup}`}>
                <input
                    type={type ?? "text"}
                    value={value}
                    id={id}
                    name={name}
                    readOnly={readOnly}
                    placeholder={placeholder}
                    onChange={(e) => onChange?.(e.target.value)}
                    onBlur={(e) => onBlur?.(e.target.value)}
                    onFocus={(e) => onFocus?.(e.target.value)}
                    onKeyUp={(e) => onKeyUp?.(e)}
                    className={`${styles.input}  ${className} ${
                        onFocus ? "" : ".input:focus"
                    }`}
                    autoComplete="off"
                />
            </div>
        </div>
    );
};
